import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import usePageMetadata from '../utils/usePageMetadata';
import './Auth.css';

const WaitlistPending = () => {
  usePageMetadata({
    title: 'Account Pending Approval | The Ad Shop',
    description: 'Your Ad Shop account is pending approval. We\'ll notify you via email once your account is ready.',
    canonicalUrl: 'https://theadshop.co/waitlist',
    meta: [
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const emailFromQuery = searchParams.get('email');
  const emailFromState = location.state?.email;
  const email = emailFromState || emailFromQuery || '';

  return (
    <div className="page-container">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <img src="/images/the-ad-shop-logo.svg" alt="The Ad Shop" className="auth-logo" />
            <h1>Thank You for Joining the Waitlist</h1>
            <p>We’re reviewing your account now.</p>
          </div>

          <div className="waitlist-content">
            <p>
              Thanks for signing up{email ? `, ${email}` : ''}! Because we manually onboard new publishers, your account
              is currently pending approval.
            </p>
            <ul>
              <li>The average approval time is a few days but can take up to a week.</li>
              <li>We'll email you as soon as your account is approved.</li>
              <li>No action needed from you right now—sit tight while we finish the review.</li>
            </ul>
          </div>

          <div className="waitlist-actions">
            <Link to="/" className="btn btn-secondary">
              Back to Home
            </Link>
            <Link to="/login" className="btn btn-primary">
              Return to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitlistPending;


